import { render, staticRenderFns } from "./my-combo-vehicle-info-business-notes.vue?vue&type=template&id=2446ad25&scoped=true"
import script from "./my-combo-vehicle-info-business-notes.vue?vue&type=script&lang=js"
export * from "./my-combo-vehicle-info-business-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2446ad25",
  null
  
)

export default component.exports